<template>
  <div class="sensor-chart-comp" v-if="hasMod">
    <div class="sensor-header" :style="{ backgroundColor: color }">
      {{ newEchartOp.title | translateTo }}
    </div>
    <div class="sensor-echart echart-parent" :id="newEchartOp.id">
      <v-chart :options="newEchartOp.options" :autoresize="true" :ref="type"></v-chart>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { merge } from 'lodash';
import { isEmpty } from '@/utils/is';

export default {
  name: 'SensorEchart',
  props: {
    color: String, // 颜色
    mod: String, // 模块
    type: String, // 对应值的key
    echartOp: Object,
    useMod: String,
    typeIndex: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      newEchartOp: merge({}, this.echartOp),
      ec: ['o2', 'no2', 'cocl2', 'hcn', 'h2s'] /** 电化学 */
    };
  },
  computed: {
    ...mapState('socket', ['singleDeviceDetail']),
    hasMod() {
      if (!this.singleDeviceDetail) return false;

      const { mods } = this.singleDeviceDetail;
      return this.useMod in mods || !this.useMod;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.newEchartOp.options?.yAxis?.name) {
        this.newEchartOp.options.yAxis.name = this.translateTo(this.echartOp.options.yAxis.name);
      }

      this.$refs[this.type]?.showLoading?.({
        text: this.$t('loading') + '...',
        color: this.color,
        textColor: '#ffffff',
        maskColor: 'rgba(17, 33, 50, 0.1)'
      });

      this.unwatch = this.$watch('singleDeviceDetail', newVal => {
        let latestVal;
        this.$refs[this.type]?.hideLoading?.();
        const { newEchartOp, mod, type, useMod } = this;
        if (type === 'windDirection') {
          const { mods } = newVal;
          const { weatherMod } = mods;
          const { windDirection, windDirectionValue } = weatherMod;
          newEchartOp.options.series[0].data.splice(0, Infinity, {
            value: windDirection,
            name: windDirectionValue
          });
          return;
        }

        if (type === 'flow') {
          latestVal = newVal.mods.cwaMod[type];
        } else if (type.indexOf('.') != -1) {
          latestVal = type.split('.').reduce((v, key) => v?.[key], newVal.mods[mod]);

          if (isEmpty(latestVal)) console.log('未获取到属性');
        } else {
          if (this.typeIndex === undefined) {
            latestVal = newVal.mods[mod][type];
          } else {
            latestVal = newVal.mods[mod][type][this.typeIndex];
          }
        }

        if (newVal.mods[useMod] && useMod === 'ecMod') {
          latestVal = newVal.mods[useMod][type].value;
        }

        if (newEchartOp.markLine && newVal.mods[mod][newEchartOp.markLine]) {
          if (newEchartOp.options.series[0].markLine) {
            newEchartOp.options.series[0].markLine.data[0].yAxis =
              newVal.mods[mod][newEchartOp.markLine];
          } else {
            this.$set(newEchartOp.options.series[0], 'markLine', {
              data: [
                {
                  name: '阈值',
                  yAxis: newVal.mods[mod][newEchartOp.markLine],
                  lineStyle: { color: newEchartOp.options.color }
                }
              ]
            });
          }
        }
        const target = newEchartOp.options.series[0].data;
        if (!target.flat(Infinity).includes(newVal.beginTime)) {
          target.push([newVal.beginTime, latestVal]);
        }

        if (newEchartOp.options.series[0].data.length >= 9) {
          newEchartOp.options.series[0].data.shift();
        }
      });
    });
  },
  beforeDestroy() {
    this.unwatch?.();
    this.$refs[this.type]?.dispose?.();
  }
};
</script>

<style lang="scss">
.sensor-chart-comp {
  margin-bottom: 10px;
  .sensor-header {
    height: 30px;
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;
    color: #fff;
  }
  .sensor-echart {
    height: 250px;
  }
}
</style>
